import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Tabs } from 'antd';
import { Page } from '../../components';
import { Query } from '../../utils';
import useStats from './useStats';
import StatsContext from './context';
import Incomes from './pages/incomes';
import Owns from './pages/owns';

import '../../styles/pages/stats/stats.scss';

const { TabPane } = Tabs;

const Stats = () => {
	const navigate = useNavigate();
	const location = useLocation();

	const { tab } = Query.decode(location.search);

	return (
		<StatsContext.Provider value={useStats()}>
			<Page title="Statystyki">
				<div className="stats">
					<Tabs activeKey={tab ?? '0'} onChange={(tab) => navigate(`?tab=${tab}`, { replace: true })}>
						<TabPane tab="Przychody" key="0" className='h-full'>
							<Incomes />
						</TabPane>
						{/* <TabPane tab="Wydatki" key="1">
							<Expenses />
						</TabPane>
						<TabPane tab="Przychody" key="2">
							<Incomes />
						</TabPane>
						<TabPane tab="Zamówienia" key="3">
							<Orders />
						</TabPane> */}
						<TabPane tab="Utylizacje" key="4">
							<Owns />
						</TabPane>
					</Tabs>
				</div>
			</Page>
		</StatsContext.Provider>
	);
};

export default Stats;
